module.exports = __webpack_public_path__ + "static/media/escalda-pes.a14c0871.jpeg";